import WorkSitesView from "../WorkSitesView.vue";
import WorkSiteList   from "../Pages/WorkSiteList.vue";
import WorkSiteEditor from "../Pages/WorkSiteEditor.vue";

const routes = [
  {
    path: "/mantenimiento/sedes",
    component: WorkSitesView,
    children: [
      {
        path: "",
        name: "work-site-list",
        component: WorkSiteList,
      },
      {
        path: "crear",
        name: "work-site-create",
        component: WorkSiteEditor,
      },
      {
        path: ":id/editar",
        name: "work-site-edit",
        component: WorkSiteEditor,
      },
    ],
  },
];

export default routes;
